import { createMiddlewareAction } from "../createMiddlewareAction"
import { infoProfileContactHospitalPresentationTypes, getProductsContactPresentationTypes } from "../../constantes/actionTypes"
import { endpointsContactPresentation } from "../../api/accessToPresentationByContact/endpoinsContactPresentation"

// Visualizar información basica de la presentación y del contacto
export const infoProfileContactHospitalPresentationActions = {
    getInfoProfileContactHospitalPresentation: (id) => (
        createMiddlewareAction({
            successType: infoProfileContactHospitalPresentationTypes.GET_INFO_CONTACT_HOSPITAL_PRESENTATION_SUCCESS,
            failureType: infoProfileContactHospitalPresentationTypes.GET_INFO_CONTACT_HOSPITAL_PRESENTATION_FAILURE,
            method: "GET",
            endpoint: endpointsContactPresentation.GET_INFO_PROFILE_CONTACT_HOSPITAL_PRESENTATION(id)
        })
    ),
}

// Visualizar los docuemntos de la presentacion
export const productsContactPresentationActions = {
    getProductsContactPresentation: (id) => (
        createMiddlewareAction({
            successType: getProductsContactPresentationTypes.GET_PRODUCTS_CONTACT_PRESENTATION_SUCCESS,
            failureType: getProductsContactPresentationTypes.GET_PRODUCTS_CONTACT_PRESENTATION_FAILURE,
            method: "GET",
            endpoint: endpointsContactPresentation.GET_PRODUCTS_CONTACT_PRESENTATION(id),
        })
    ),
}